import { toast } from "sonner";
import { captureException } from "@sentry/react";

/**
 * Calls toast.info and console.log with the given message, any extra info is passed to console.log
 */
export const toastAndInfo = (message: string, ...data: unknown[]) => {
  console.log(message, ...data);
  toast.info(message);
};

/**
 * Calls toast.warning and console.warn with the given message, any extra info is passed to console.warn
 */
export const toastAndWarn = (message: string, ...data: unknown[]) => {
  console.warn(message, ...data);
  toast.warning(message);
};

/**
 * Calls toast.error and console.error with the given message, any extra info is passed to console.error
 */
export const toastAndError = (message: string, ...data: unknown[]) => {
  console.error(message, ...data);
  captureException(new Error(message), {
    extra: {
      "Captured err": data,
    },
  });
  toast.error(message);
};
